<div class="filter-container">
    <button class="filter-btn" (click)="togglePanel()">
        <span class="icon-container">
            <img *ngIf="!filterApplied" src="assets/icons/16x16_filter.svg" />
            <img *ngIf="filterApplied" src="assets/icons/16x16_filter-applied.svg" />
        </span>
        <span class="label-button"> {{'FILTER.TEXT' | translate}}</span>
    </button>

    <div class="panel" *ngIf="isOpen">
        <div *ngFor="let group of configuration;let last = last" class="group">
            <div class="group-title">{{ group.text }}</div>

            <div *ngFor="let option of group.options" class="option">
                <label>
                    <input type="radio" name="group-{{ group.id }}" [checked]="option.selected" (click)="selectOption(group, option)" />
                    {{ option.text }}
                </label>
            </div>
            <hr *ngIf="!last" />
        </div>
    </div>
</div>